export default __webpack_public_path__ + "static/media/captcha-error.b634e0c7.svg";